module.exports = __webpack_public_path__ + "img/news15_3.15db0db5.jpg";